import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export const useCreateMatchmakingApplyFundProjectLink = () => {
  const [fetch, response] = useRequest();

  const createMatchmakingApplyFundProjectLink = useCallback(
    (fundId: number, projectId: number) =>
      fetch(API.paths.matchmaking_apply_create_project_link(fundId), 'post', {
        data: {
          project_id: projectId,
        },
      }),
    [fetch],
  );

  return [createMatchmakingApplyFundProjectLink, response] as const;
};
